import React from 'react';

interface StatCardProps {
  title: string;
  value: string;
  description: string;
  icon: React.ReactNode;
  gradientColors: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  description,
  icon,
  gradientColors,
}) => {
  return (
    <div className={`rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300`}>
      <div className={`bg-gradient-to-br ${gradientColors} p-6`}>
        <div className="flex items-start">
          <div className="mr-4">{icon}</div>
          <div>
            <h3 className="font-semibold text-gray-700 mb-1">{title}</h3>
            <div className="text-3xl font-bold text-gray-900 mb-1">{value}</div>
            <p className="text-sm text-gray-600">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;